import defaultAuthorizationService, { AuthorizationService } from "authorization/service/AuthorizationService";
import { DefaultRequestStatus, RequestStatus } from "ecom-teams-apps-core";
import { action, makeObservable, observable } from "mobx";
import { UserIdentity } from "shared/models/UserIdentity";
import { UserIdentityFromResponse } from "tasksBoard/service/UserIdentityFromResponse";

export interface AuthorizationStore {
    currentUser: UserIdentity | null;

    authorizeRequestStatus: RequestStatus;

    authorize: (
        useDevelopmentAuth: boolean,
        withRefresh?: boolean,
        username?: string,
        password?: string
    ) => Promise<void>;
}

export class DefaultAuthorizationStore implements AuthorizationStore {
    constructor(private authorizationService: AuthorizationService, private authorizeReqStatus: RequestStatus) {
        makeObservable(this, {
            authorize: action,
            currentUser: observable
        });
    }

    public currentUser: UserIdentity | null = null;

    public get authorizeRequestStatus() {
        return this.authorizeReqStatus;
    }

    public async authorize(useDevelopmentAuth: boolean, withRefresh?: boolean, username?: string, password?: string) {
        if (withRefresh) {
            await this.authorizationService.teamsAuthorize();
            return;
        }

        const user = await this.authorizeReqStatus.handleAnyRequest(() => {
            return useDevelopmentAuth
                ? this.authorizationService.authorize(username, password)
                : this.authorizationService.teamsAuthorize();
        });

        if (user) {
            this.currentUser = new UserIdentityFromResponse(user).userIdentity();
        }
    }
}

export default new DefaultAuthorizationStore(defaultAuthorizationService, new DefaultRequestStatus());
